import { LogLevel } from 'configcat-react';

import { isDev, useMocks } from '#configuration/env.ts';

const asBool = (value: string | undefined): boolean => value === 'true';

export interface ConfigState {
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
    };
    homeRoute: string | undefined;
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri: string | undefined;
    fleetMonitorUrl: string;
    applicationName: string;
    serviceVersion: string;
    sentryToken: string | undefined;
    hereBaseUrl: string;
    hereApiKey: string | undefined;
    configCat: {
        apiKey: string | undefined;
        logLevel: LogLevel | undefined;
        cacheTimeInSeconds: number | undefined;
    };
    dataDogClientToken: string;
}

export const config = {
    backend: {
        AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
        MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
    },
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: ['ordercom-cartright.read', 'ordercom-cartright.write', 'email', 'openid', 'phone', 'profile'],
        mockAuthorization: useMocks,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: isDev,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    fleetMonitorUrl: import.meta.env.VITE_FLEET_MONITOR_URL,
    applicationName: 'Order Communication',
    serviceVersion: '1.0.1',
    sentryToken: import.meta.env.VITE_SENTRY_TOKEN,
    hereBaseUrl: 'https://js.api.here.com/v3/3.1/',
    hereApiKey: import.meta.env.VITE_HERE_API_KEY,
    configCat: {
        apiKey: import.meta.env.VITE_APP_CONFIG_CAT_API_KEY ?? '',
        logLevel: import.meta.env.VITE_APP_CONFIG_CAT_LOG_LEVEL === 'INFO' ? LogLevel.Info : LogLevel.Off,
        cacheTimeInSeconds: 60,
    },
    dataDogClientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
} satisfies ConfigState;
